<template>
    <td-dialog :title="$t(title)" :before-close="dialogNextUserDialogColse" :visible.sync="dialogNextUserVisible" width="1200px" :close-on-click-modal="false" :close-on-press-escape="false" top="5vh">
        <el-form :model="formInfo" ref="formInfo" :rules="rules" label-position="right" label-width="150px" type="flex" :inline="true">
            <el-row v-for="targetIndex in targetTasks" :key="targetIndex" :gutter="24" style="margin-bottom: 10px;">
                <el-form-item :label="$t('pgCommon.NEXT_NAME')">
                    <td-input v-model="targetIndex.name" type="text" :disabled="true"></td-input>
                </el-form-item>
                <el-form-item :label="$t('pgCommon.NEXT_USER')">
                    <td-select v-model="targetIndex.nextUsers" :options="nextUsersOptions"></td-select>
                </el-form-item>
                <el-form-item :label="$t('pgCommon.NEXT_GROUP')">
                    <td-select v-model="targetIndex.nextGroups" :options="nextGroupsOptions"></td-select>
                </el-form-item>
            </el-row>
        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="saveLoading" @click="submitForm('formInfo')">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="dialogNextUserDialogColse">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import Api from '../assets/api.js';
export default {
    props: ['item', 'dialogNextUserVisible', 'title', 'templateKey'],
    created() {
        this.initPage();
    },
    mounted() {},
    // 定义变量
    data() {
        return {
            targetTasks: [],
            nextUsersOptions: [
                {
                    value: 'nextUsers_upLeavel',
                    label: this.$t('pgCommon.UPLEAVEL_USER')
                },
                {
                    value: 'nextUsers_downLeavel',
                    label: this.$t('pgCommon.DOWNLEAVEL_USER')
                }
            ],
            nextGroupsOptions: [
                {
                    value: 'nextGroups_upLeavel',
                    label: this.$t('pgCommon.UPLEAVEL_GROUP')
                },
                {
                    value: 'nextGroups_downLeavel',
                    label: this.$t('pgCommon.DOWNLEAVEL_GROUP')
                }
            ]
        };
    },
    // destroyed() {
    //     this.componentOptionsMap.clear();
    //     this.infoMap.clear();
    // },
    computed: {},
    // 定义并实现方法体
    methods: {
        // 保存条件逻辑
        submitForm(formInfo) {
            for (let index in this.targetTasks) {
                if (!this.targetTasks[index].nextUsers) {
                    this.targetTasks[index].nextUsers = "null";
                }
                if (!this.targetTasks[index].nextGroups) {
                    this.targetTasks[index].nextGroups = "null";
                }
                let param = {
                    sId: this.templateKey + ':' + this.item.taskKey + ':' + this.targetTasks[index].key,
                    processDefKey: this.templateKey,
                    taskDefKey: this.targetTasks[index].key,
                    userIds: this.targetTasks[index].nextUsers,
                    userNames: this.targetTasks[index].nextUsers,
                    roleIds: this.targetTasks[index].nextGroups,
                    roleNames: this.targetTasks[index].nextGroups,
                    flag: 0,
                    proDefId: this.templateKey + ':TEMP'
                };
                Api.saveNodeUser(JSON.stringify(param), response => {
                    if (this.$t(this.$common.requestCode.SUCCESS_INFO_CODE) != response.data.statusCode) {
                        this.loading = false;
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('role/getRoleAuthList', response.data.statusMessage);
                        return;
                    }
                    this.$message({ showClose: true, message: this.$t('pgCommon.ADD_SUCCESS'), type: 'success' });
                    this.dialogNextUserDialogColse();
                });
            }
        },
        // 初始化页面
        initPage() {
            let para = {
                templateId: this.item.templateId,
                taskKey: this.item.taskKey
            };
            Api.getTaskOutgoings(para, response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.$log.error('templateManage/getTaskOutgoings', response);
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('templateManage/getTaskOutgoings', response.data.statusMessage);
                    return;
                }
                var initData = response.data.content;
                for (let index in initData.targetTaskKeys) {
                    if (initData.targetTaskKeys[index] && initData.targetTaskKeys[index] != 'EndEvent') {
                        let item = {
                            key: initData.targetTaskKeys[index],
                            name: initData.targetTaskNames[index],
                            nextUsers: '',
                            nextGroups: ''
                        };
                        this.targetTasks.push(item);
                    }
                }
                for (let index in this.targetTasks) {
                    let param = {
                        sId: this.templateKey + ':' + this.item.taskKey + ':' + this.targetTasks[index].key,
                        processDefKey: this.templateKey,
                        taskDefKey: this.targetTasks[index].key,
                        proDefId: this.templateKey + ':TEMP'
                    };
                    Api.queryNodeUser(JSON.stringify(param), response => {
                        if (response.status !== this.$common.login.RESPONSE_STATUS) {
                            this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                            this.loading = false;
                            this.$log.error('queryNodeUser', response);
                            return;
                        }
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                            this.$log.error('queryNodeUser', response.data.statusMessage);
                            return;
                        }
                        if (response.data.content.length > 0) {
                            let userStr = response.data.content[0].userIds;
                            let roleStr = response.data.content[0].roleIds;
                            this.targetTasks[index].nextUsers = userStr;
                            this.targetTasks[index].nextGroups = roleStr;
                        }
                    });
                }
            });
        },
        dialogNextUserDialogColse() {
            this.dialogNextUserVisible = false;
            this.$emit('dialogNextUserDialogColse');
        }
    }
};
</script>
